import {
  ChangeDetectionStrategy, Component, createNgModule, OnInit, ViewChild, ViewContainerRef,
  Injector,
  ComponentRef,
  
  inject, DestroyRef,
  
} from '@angular/core';


  import { FeatureToggleService } from 'ish-core/feature-toggle.module';
  import { takeUntilDestroyed } from '@angular/core/rxjs-interop';


import type { RecentlyViewedComponent as OriginalComponent } from '../../shared/recently-viewed/recently-viewed.component';

@Component({
  selector: 'ish-lazy-recently-viewed',
  templateUrl: './lazy-recently-viewed.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class LazyRecentlyViewedComponent implements OnInit {
  /*
   * WARNING!
   *
   * This file was automatically generated!
   * It should be updated using:
   *
   * ng g lazy-component extensions/recently/shared/recently-viewed/recently-viewed.component.ts
   *
   */

  @ViewChild('anchor', { read: ViewContainerRef, static: true }) anchor: ViewContainerRef;



  private component: ComponentRef<OriginalComponent>;
   private destroyRef = inject(DestroyRef);

  constructor(
    private featureToggleService: FeatureToggleService,
    private injector: Injector
  ) {}

   ngOnInit() {
     this.featureToggleService.enabled$('recently').pipe(takeUntilDestroyed(this.destroyRef)).subscribe(async enabled => {
      if (enabled) {
    

      await this.renderComponent();

    
        } else {
          this.anchor.clear();
        }
      })
    
  }

  private async renderComponent() {
    const module = await import(`../../recently.module`).then(m => m.RecentlyModule);

    const { RecentlyViewedComponent: originalComponent } = await import('../../shared/recently-viewed/recently-viewed.component');

    const ngModuleRef = createNgModule(module, this.injector);

    this.component = this.anchor.createComponent(originalComponent, { ngModuleRef });
  
    this.component.changeDetectorRef.markForCheck();
  }


}
